import { render, staticRenderFns } from "./RankPopup.vue?vue&type=template&id=3454509b&scoped=true&"
import script from "./RankPopup.vue?vue&type=script&lang=js&"
export * from "./RankPopup.vue?vue&type=script&lang=js&"
import style0 from "./RankPopup.vue?vue&type=style&index=0&id=3454509b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454509b",
  null
  
)

export default component.exports